export const SUBSCRIPTION_TYPE_1 = '1 Credit'
export const SUBSCRIPTION_TYPE_2 = 'Month'
export const SUBSCRIPTION_TYPE_3 = 'Year'